const supportTouch = 'ontouchstart' in window
if (supportTouch) {
  require('./polyfill/dragdropon.js')
}
const VueDragAndDrop = {
  install: function (Vue) {
    Vue.directive('drag-and-drop', {
      bind: function (el, binding, vnode) {
        el.handleDragStart = function (e) {
          e.target.classList.add('dragging')
          e.dataTransfer.effectAllowed = 'move'
          // Need to set to something or else drag doesn't start
          e.dataTransfer.setData('text', '*')
          vnode.context.$emit('drag-start')
        }

        el.handleDragOver = function (e) {
          if (e.preventDefault) {
            // allows dropping
            e.preventDefault()
          }

          e.dataTransfer.dropEffect = 'move'
          e.target.classList.add('drag-over')
          vnode.context.$emit('drag-over')

          // return false
        }

        el.handleDragEnter = function (e) {
          vnode.context.$emit('drag-enter')
          e.target.classList.add('drag-enter')
        }

        el.handleDragLeave = function (e) {
          vnode.context.$emit('drag-leave')
          e.target.classList.remove('drag-enter', 'drag-over')
        }

        el.handleDrag = function () {
          vnode.context.$emit('drag')
        }

        el.handleDragEnd = function (e) {
          e.target.classList.remove('dragging', 'drag-over', 'drag-enter')
          vnode.context.$emit('drag-end')
        }

        el.handleDrop = function (e) {
          e.preventDefault()
          if (e.stopPropagation) {
            // stops the browser from redirecting.
            e.stopPropagation()
          }

          // Don't do anything if dropping the same column we're dragging.
          vnode.context.$emit('drop')

          return false
        }

        // setup the listeners
        el.setAttribute('draggable', 'true')
        el.addEventListener('dragstart', el.handleDragStart, false)
        el.addEventListener('dragenter', el.handleDragEnter, false)
        el.addEventListener('dragover', el.handleDragOver, false)
        el.addEventListener('drag', el.handleDrag, false)
        el.addEventListener('dragleave', el.handleDragLeave, false)
        el.addEventListener('dragend', el.handleDragEnd, false)
        el.addEventListener('drop', el.handleDrop, false)
      },
      unbind: function (el) {
        // shut er' down
        el.classList.remove('dragging', 'drag-over', 'drag-enter')
        el.removeAttribute('draggable')
        el.removeEventListener('dragstart', el.handleDragStart)
        el.removeEventListener('dragenter', el.handleDragEnter)
        el.removeEventListener('dragover', el.handleDragOver)
        el.removeEventListener('dragleave', el.handleDragLeave)
        el.removeEventListener('drag', el.handleDrag)
        el.handleDragStart = null
        el.handleDragEnter = null
        el.handleDragOver = null
        el.handleDragLeave = null
        el.handleDrag = null
      }
    })
  }
}
export default VueDragAndDrop
